import styled from "styled-components";
import PremiumLoadingCard from "../premium/PremiumLoadingCard";

const LoadingSurface = styled.div`
    position: fixed;
    inset: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 12px;
    overflow-y: auto;
    background: #080909;
`;

// Keep the account-loading gate: protected children are unmounted while loading.
export default function WorkspaceLoader({ isLoading, className, children }) {
    return <div className={className}>
        {isLoading ? <LoadingSurface>
            <PremiumLoadingCard title="PREPARING YOUR WORKSPACE"
                header="Getting BOstageR ready for you"
                footer="We're loading your organization, confirming access to your brands and tools, and preparing your workspace."
                showHeader showFooter />
        </LoadingSurface> : children}
    </div>;
}
